import Vue from "vue";
/**
 *
 * @param el
 * @param param1
 */
export const appWeirdTextDirective = {
  created: (el: HTMLElement, { value }: any, vnode: any) => {
    const title = el.querySelector(".app-weird-text") as HTMLElement;
    if (!title) {
      console.error(
        `el = ${el} is using appWeirdTextDirective without innertitle`
      );
      return;
    }
    /**
     * Takes random chars in the elements and animates each one of them
     * from up to lower e.t.c
     */
    el.addEventListener("mouseenter", () => {
      let modValue: string = value;
      setInterval(() => {
        if (modValue === modValue.toUpperCase()) {
          return;
        }
        const randomIndex = Math.floor(Math.random() * value.length);
        const char = value.charAt(randomIndex).toUpperCase();
        modValue =
          modValue.substring(0, randomIndex) +
          char +
          modValue.substring(randomIndex + 1);
        title.innerText = modValue;
      }, 100);
    });

    /**
     * returns the title back to og text
     */
    el.addEventListener("mouseleave", () => {
      title.innerText = value;
      clearInterval();
    });
  },
};
